import themes from '@bnnvara/themes';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Icon = ({
  className,
  color
}) => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22",
  "aria-label": "zoek",
  className: className
}, /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-8.000000, -7.000000)",
  stroke: color,
  strokeWidth: "3"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.000000, 7.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.9853906,13.9853906 L20.5434783,20.5434783"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "9.13043478",
  cy: "9.13043478",
  r: "7.63043478"
}))))));

Icon.propTypes = {
  className: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired
};
const StyledIcon = styled(Icon)`
  width: ${props => props.width};
  height: ${props => props.height};
`;
StyledIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string
};
StyledIcon.defaultProps = {
  width: '22px',
  height: '22px',
  color: themes.bnnvara.base.white
};
export default StyledIcon;